<div class="header">
    <h2>{{ 'news.modal.view.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="news-view-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'news.error.unavailable' | translate" />
} @else if (newsItem(); as newsItem) {
    <div class="body">
        <div class="entity-header">
            <div class="entity-identity">
                <h2>{{ newsItem.title }}</h2>
            </div>
        </div>

        <div class="meta-strip">
            <div class="meta-item">
                <span class="meta-label">{{ 'news.form.date' | translate }}</span>
                <span class="meta-value">{{ newsItem.date | date: 'mediumDate' }}</span>
            </div>
        </div>

        <div class="section">
            <h2>{{ 'news.fieldset.content' | translate }}</h2>
            @if (newsItem.description) {
                <p class="description">{{ newsItem.description }}</p>
            } @else {
                <p class="description empty">{{ 'common.notProvided' | translate }}</p>
            }
        </div>
    </div>

    <div class="footer">
        <app-delete-button [newsItemId]="newsItem.id" [saving]="saving()" testId="news-view-delete" />
        <p-button [label]="'news.detail.edit' | translate" icon="pi pi-pencil" data-test="news-view-edit" (onClick)="onEdit()" />
    </div>
}
